var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnionCenterArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 56,
    viewBox: "0 0 37 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9564 0H19.4025H19.786V49.2521C20.9015 47.2814 22.2523 45.2285 23.8064 43.3499C26.9879 39.5038 31.2728 36.0915 36.3589 36.0915V38.9211C32.5659 38.9211 29.0051 41.5046 25.9866 45.1535C23.0059 48.7567 20.7989 53.1107 19.6924 56L18.1795 55.7202L16.6665 56C15.56 53.1108 13.353 48.7567 10.3723 45.1535C7.3538 41.5046 3.79294 38.9211 0 38.9211V36.0915C5.08609 36.0915 9.37094 39.5039 12.5525 43.3499C14.1066 45.2285 15.4574 47.2814 16.5729 49.2521V0H16.9564Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnionCenterArrow);
export default __webpack_public_path__ + "static/media/union_center_arrow.36c461d73339b027626b58d3bf953a2c.svg";
export { ForwardRef as ReactComponent };